import { Typography } from 'gu-ui-kit'
import clsx from 'clsx'
import styles from 'layouts/AuthLayout/AuthLayout.module.scss'
import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { SET_I18N } from 'modules/App/types'
import { LOCALES } from 'constants/app-config'
import { selectAppLocale } from 'modules/App/store/selectors'

export const Langs = () => {
  const i18n = useSelector(selectAppLocale)
  const dispatch = useDispatch()

  const handleClick = useCallback((lang) => {
    dispatch({ type: SET_I18N, payload: { i18n: lang } })
  }, [])

  if (LOCALES.length < 2) {
    return null
  }

  return LOCALES.map((lang) => (
    <Typography
      component={'button'}
      variant={'Body-15'}
      color={i18n === lang ? 'Label-Primary' : 'Label-Secondary'}
      className={clsx(styles['layout__lang-button'], {
        [styles['layout__lang-button_active']]: i18n === lang,
      })}
      key={lang}
      type={'button'}
      onClick={() => handleClick(lang)}
    >
      {lang}
    </Typography>
  ))
}
